module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vuePerfectLayout",
    attrs: {
      "name": "vue-perfect-layout"
    }
  }, [_c('div', {
    attrs: {
      "id": "gallery"
    }
  }, [_vm._l((_vm.photoColumnsRows), function(photoColumnsRow) {
    return [_vm._l((photoColumnsRow), function(photoColumnRow) {
      return [_c('a', {
        attrs: {
          "href": "javascript:void(0)"
        }
      }, [_c('div', {
        staticClass: "image",
        on: {
          "click": function($event) {
            return _vm.triggerDetail(photoColumnRow.folder)
          }
        }
      }, [_c('img', {
        style: (photoColumnRow.style),
        attrs: {
          "src": photoColumnRow.src
        },
        on: {
          "contextmenu": _vm.disabledRightClick
        }
      })])])]
    })]
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-29ad50be!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vuePerfectLayout/components/index.vue
// module id = 582
// module chunks = 2